<template>
    <div class="float-left mr-1">
        <b-button
            variant="primary"
            @click.stop="abrirModalInserirResponsavel()"
        >
            <span> <i class="fa fa-plus mr-2"></i> Inserir Responsável </span>
        </b-button>
        <b-modal
            id="modalInserirResponsavel"
            v-model="mostrarModalInserirResponsavel"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Responsável -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O quê deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group v-model="contratoApostilamento"  @change="alternaJustificativa($event)">
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Funcionário</label>
                        <b-form-select
                            :options="funcionarios"
                            v-model="codFuncionario"
                            text-field="nome"
                            value-field="codFuncionario"
                            @input="$v.codFuncionario.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Responsabilidade</label>
                        <b-form-select
                            :options="responsabilidades"
                            v-model="responsabilidadeId"
                            text-field="descricao"
                            value-field="responsabilidadeId"
                            @input="$v.responsabilidadeId.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{textoInfoJustificativa}} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalInserirResponsavel()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarResponsavel()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'
import FuncionariosServicos from './../../rm/FuncionariosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarModalInserirResponsavel: false,
            obterResponsaveisAtualizados: false,
            operacao: 'INSERÇÃO',
            erros: [],
            codFuncionario: null,
            responsabilidadeId: null,
            funcionarios: [],
            responsabilidades: [],
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        obterFuncionariosResponsabilidades() {
            this.$store.dispatch('addRequest')
            FuncionariosServicos.obterFuncionariosResponsabilidades().then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.responsabilidades =
                                response.data.responsabilidades
                            this.funcionarios = response.data.funcionarios
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        abrirModalInserirResponsavel() {
            this.mostrarModalInserirResponsavel = true
        },

        fecharModalInserirResponsavel() {
            this.mostrarModalInserirResponsavel = false
            this.resetInserirResponsavel()
            if (this.obterResponsaveisAtualizados) {
                this.$emit('obterResponsaveisAtualizados')
            }
        },

        resetInserirResponsavel() {
            this.justificativaApostilamento = ''
            this.erros = []
            this.codFuncionario = null
            this.responsabilidadeId = null
            this.funcionarios = []
            this.responsabilidades = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterFuncionariosResponsabilidades()
        },

        confirmarSalvarResponsavel() {
            this.$swal({
                title: 'Responsável pelo Contrato',
                html: `Confirma a inserção da responsabilidade no contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarResponsavel()
                }
            })
        },

        salvarResponsavel() {
            this.$store.dispatch('addRequest')
            let responsavelDto = {
                idContrato: this.contrato.idContrato,
                idResponsavelContrato: 0,
                codFuncionario: this.codFuncionario,
                responsabilidadeId: this.responsabilidadeId,
                justificativaApostilamento: this.justificativaApostilamento,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.atualizarResponsavel(responsavelDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.obterResponsaveisAtualizados = true
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.fecharModalInserirResponsavel()
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                ((this.$temAcessoView('CONT-ELAB-00') &&
                    (this.contrato.idSituacaoContrato ==
                        situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                        this.contrato.idSituacaoContrato ==
                            situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO)))
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        atualizacaoContrato() {
            return (this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido())
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if(this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if((this.apostilamento || this.atualizacaoContrato()) && this.contratoApostilamento != null) {
                return true
            } else if(this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if(this.$temAcessoView('CONT-ATUALIZAR-00') && this.$temAcessoView('CONT-APOST-03')) {
                this.contratoApostilamento = null
            } else if(this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if(this.$temAcessoView('CONT-APOST-03')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }

    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },
        
        mostrarCheckApostilamento() {
            return (
                this.atualizacaoContrato() && this.apostilamento
            )
        },
    },

    watch: {},

    validations: {
        codFuncionario: {
            required
        },
        responsabilidadeId: {
            required
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}
</script>
